/**
 * @generated SignedSource<<d5f57e9998123aef04032941d22de437>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreCalendarSubscribeInput = {
  calendarName?: string | null;
  url: string;
};
export type CalendarSubscribeMutation$variables = {
  input: StoreCalendarSubscribeInput;
};
export type CalendarSubscribeMutation$data = {
  readonly store: {
    readonly subscribeToCalendar: {
      readonly id: string;
      readonly store: {
        readonly calendarAddSuggestions: ReadonlyArray<{
          readonly iCalUrl: string;
          readonly title: string;
        }>;
      };
    };
  };
};
export type CalendarSubscribeMutation = {
  response: CalendarSubscribeMutation$data;
  variables: CalendarSubscribeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarSuggestion",
  "kind": "LinkedField",
  "name": "calendarAddSuggestions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iCalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarSubscribeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "subscribeToCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarSubscribeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "subscribeToCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81d7bba9b106ad89b4ca90a8813847ff",
    "id": null,
    "metadata": {},
    "name": "CalendarSubscribeMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarSubscribeMutation(\n  $input: StoreCalendarSubscribeInput!\n) {\n  store {\n    subscribeToCalendar(input: $input) {\n      id\n      store {\n        calendarAddSuggestions {\n          iCalUrl\n          title\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "37b4431639feaa069b8345fc934b2249";

export default node;
